import useChatPersistence from "src/components/Chat/hooks/useChatPersistence";
import useChatConnection from "src/components/Chat/hooks/useChatConnection";
import useLogChatSettingsError from "src/components/Chat/hooks/useLogChatSettingsError";
import useChatCarryOver from "src/components/Chat/hooks/useChatCarryOver";

export default function useConversations() {
    useLogChatSettingsError();
    useChatCarryOver();
    useChatConnection();
    useChatPersistence();
}
